const Sage = window.Sage;
const grecaptcha = window.grecaptcha;

export default {
  init() {
    $('.survey-form button[type=submit]').on('click', function (e) {
      e.preventDefault();

      grecaptcha.ready(function () {
        grecaptcha
          .execute(Sage.recaptcha_site_key, { action: 'submit' })
          .then(function (token) {
            $('#token').val(token);

            $('.survey-form').trigger('submit');
          });
      });
    });

    // Local storage save checkboxes
    $('.survey-form input').each(function () {
      const type = $(this).attr('type');

      let key = $(this).attr('name');

      if ('checkbox' == type) {
        key += '-' + $(this).val();
      }

      const storage = localStorage.getItem(key);

      if (storage && (storage == 'true' || storage == $(this).val())) {
        $(this).prop('checked', true);
      } else {
        $(this).prop('checked', false);
      }
    });

    $('.survey-form input').on('change', function () {
      const type = $(this).attr('type');
      let key = $(this).attr('name');
      let val = null;

      if ('checkbox' == type) {
        key = key + '-' + $(this).val();
        val = $(this).prop('checked');
      }

      if ('radio' == type) {
        val = $(this).val();
      }

      localStorage.setItem(key, val);
    });
  },
};
